import { query_customer_activation_active_list_by_date_range } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-customer_activation_active-config';

import { reactive } from 'vue';
import { get_gender, getDate } from '@/utils/function';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY);

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'rangepicker',
      name: 'date_range',
      label: '日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      format: 'YYYY-MM-DD',
      valueFormat: 'YYYY-MM-DD',
      showTime: false,
      placeholder: '请选择日期',
    },
    {
      type: 'remoteselect',
      name: 'adviser_id',
      label: '所属顾问',
      disabled: false,
      placeholder: '请选择所属顾问',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '门店',
      placeholder: '请选择门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    adviser_id: null,
    shop_id: null,
    date_range: null,
  }),
};
const search_options = {};

const edit_model_config = {};
const edit_model_config_options = {};

const update_model_config = {};
const update_model_config_options = {};

const titleList = {
  title: '客户激活列表',
  addModalTitle: '新建客户激活列表',
  updateTitle: '编辑客户激活列表',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    id: 'id',
  },
  delete: {
    id: 'id',
  },
  recover: {
    id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '客户编号',
    dataIndex: 'customer__code',
    width: 130,
  },
  {
    title: '客户姓名',
    width: 120,
    dataIndex: 'customer__name',
    checked: true,
  },
  {
    title: '会籍门店',
    width: 120,
    dataIndex: 'customer__shop__name',
    checked: true,
  },
  {
    title: '所属顾问',
    width: 120,
    dataIndex: 'customer__adviser__name',
    checked: true,
  },
  {
    title: '获客方式',
    width: 120,
    dataIndex: 'customer__hk_type__name',
    checked: true,
  },
  {
    title: '性别',
    width: 150,
    dataIndex: 'customer__gender',
    checked: true,
    content: (record: any, text: any) => {
      return get_gender(text);
    },
  },
  {
    title: '电话',
    width: 120,
    dataIndex: 'customer__phone',
    checked: true,
  },
  {
    title: '休眠时间',
    width: 120,
    dataIndex: 'start_datetime',
    checked: true,
    content: (record: any, text: any) => {
      return getDate(text);
    },
  },
  {
    title: '激活时间',
    width: 120,
    dataIndex: 'end_datetime',
    checked: true,
    content: (record: any, text: any) => {
      return getDate(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
// newSlotList.push({
//   type: 'custom',
//   // slotName: 'is_active',
//   field_true: '可用',
//   field_false: '作废',
// });

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_customer_activation_active_list_by_date_range,
    addData: null,
    updateData: null,
    removeData: null,
    recoverData: null,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
    rowKey: '_index',
  };
};
